/* eslint-disable @typescript-eslint/naming-convention */

export type markupDataType = 'FLAT'| 'PERCENTAGE' | 'MULTIPLIER';
export type markupType = {
    markup_type: markupDataType;
    markup_value: number;
    markup_price: number;
};

export enum bundlePricingLevel {
	BUNDLE = 'BUNDLE',
	ROLLUP = 'ROLLUP',
}

export enum displayBundlePricingLevel {
    'BUNDLE' = 'text.bundle_pricing_bundle',
    'ROLLUP' = 'text.bundle_pricing_rollup'
}
